import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Parallax } from 'react-scroll-parallax';
import './VideoTitleWithOverlay.scss';

export enum VTOType {
  video,
  image
}

interface VideoTitleProps {
  videoSource?: string;
  overlayDelayInSeconds: number;
  imageSource: string;
  type: VTOType
  children: React.ReactNode; // <- Add this
}

export const VideoTitleWithOverlay: React.FC<VideoTitleProps> = ({ videoSource, imageSource, type, overlayDelayInSeconds, children }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    setShowOverlay(false);

    const timeoutId = window.setTimeout(() => {
      setShowOverlay(true); // show the logo overlay
    }, overlayDelayInSeconds * 1000);

    return () => window.clearTimeout(timeoutId);
  }, [overlayDelayInSeconds]);

  return (
    <motion.div className="vto-intro-section" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 2 }}>

      {
        type === VTOType.video ?
          <video className='vto-videoTag' autoPlay loop muted disablePictureInPicture playsInline>
            <source src={videoSource} type='video/mp4' />
          </video> :
          <img className='vto-imageTag' src={imageSource} alt=""/>

      }
      <div className={`vto-overlay ${showOverlay ? 'vto-overlay-visible' : ''}`}>
        <Parallax className="vto-title-container" speed={-10}>
          {children}
        </Parallax>
      </div>
    </motion.div>
  );
}

export default VideoTitleWithOverlay;
